import { COLORS } from '@avalara/bat-apps-shared/constants';

import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';

import styled from 'styled-components';

const SubscriptionDetailContainer = styled.main`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  s-icon {
    color: ${COLORS.darkBlue};
    padding-right: 10px;
  }

  h1 {
    line-height: 34px;
    padding: 30px 0;
  }

  h2 {
    line-height: 30px;
    padding-bottom: 15px;
  }

  p {
    font-size: 18px;
    line-height: 24px;
    padding: 8px 0;
    color: ${COLORS.grayBlack};
  }
`;

const SubscriptionDetails = () => (
  <SubscriptionDetailContainer>
    <h1>{t('client.headings.ready-for-an-api-subscription-plan')}</h1>
    <h2 className='alt'>{t('client.headings.your-api-subscription-gives-you')}:</h2>
    <div>
      <p>
        <SIcon name='check' aria-label='check-mark' />
        {t('client.general.a-single-unified-api-for-sales-and-use-tax-vat-cross-border')}
      </p>
      <p>
        <SIcon name='check' aria-label='check-mark' />
        {t('client.general.fast-tax-calculation-for-transactions-across-tens-of-thousan')}
      </p>
      <p>
        <SIcon name='check' aria-label='check-mark' />
        {t('client.general.comprehensive-documentation-sdks-in-major-languages-monthly')}
      </p>
    </div>
  </SubscriptionDetailContainer>
);
export default SubscriptionDetails;
